export enum TitleOperationTypeEnum {
  'Aquisição' = 1,
  'Cobrança Simples' = 2,
  'Garantia' = 3,
  'Ex Aquisição' = 4,
}
